import { useMemo } from "react";

const VIEWS = ["back", "left", "right"];

// Mini thumbnails of the AI back/side views, floating over the front render while the build runs.
export const BuildViewsOverlay = ({ creation }) => {
  const { render_views: views, render_back: back } = creation;
  const available = useMemo(
    () => VIEWS.map((v) => [v, views?.[v] || (v === "back" ? back : null)]).filter(([, src]) => src),
    [views, back],
  );
  if (!available.length) return null;
  return (
    <div data-testid="build-views" className="absolute bottom-3 right-3 left-3 flex justify-end gap-2">
      {available.map(([v, src]) => (
        <figure key={v} data-testid={`build-${v}-view`} className="w-[26%] rounded-2xl overflow-hidden border-2 border-background shadow-lg bg-card">
          <img src={src} alt={`AI ${v} view`} className="w-full aspect-square object-cover" />
          <figcaption className="text-[10px] font-mono2 uppercase tracking-widest text-center py-1 bg-background/90">{v} view</figcaption>
        </figure>
      ))}
    </div>
  );
};
